import {
  Link,
  VStack,
} from '@ayble-health/dashboard-components';
import { useEffect } from 'react';
import { useDashboardPageState } from '../../../hooks/useDashboardPageState';
import { ExternalLinkIcon } from 'lucide-react';

const { REACT_APP_HEALTHIE_URL } = process.env;

export const PharmacyPage = () => {
  const {
    state: { user },
  } = useDashboardPageState();

  const openInHealthie = () => {
    // launch labs in new window
    const labUrl = user?.healthie_id
      ? `${REACT_APP_HEALTHIE_URL}/users/${user.healthie_id}`
      : null;
    if (labUrl) {
      window.open(labUrl, 'healthie');
    }
  };

  useEffect(() => {
    // open new Healthie window when page mounts
    openInHealthie();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <VStack h={'100%'} minH={'50vh'} flex={1} align={'center'} justify={'space-evenly'}>
      <Link onClick={openInHealthie} color={'bluegrey'}>
        Open in Healthie
        <ExternalLinkIcon size={16} />
      </Link>
    </VStack>
  );
};

export default PharmacyPage;
